import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import "./features/i18n/i18n";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./app/router";
import "./lib/api-interceptor";
// Refiner (in-app ABP survey) loads via a <script> in public/index.html; the
// trigger lives in DefaultHome, so no import is needed here.

// Amplify is now used only for Auth (the Cognito session manager) while the
// SPA bootstrap bridge is pending. All API traffic goes through
// `lib/simpl-api-client.ts` via the `lib/api-interceptor.ts` monkey-patch,
// which owns URL resolution, credentials, and headers — so the Amplify
// REST API endpoint config is no longer needed.
Amplify.configure({
  ...awsExports,
  storage: localStorage
});

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
